module.exports = __webpack_public_path__ + "img/time.1a2009e7.svg";